import React, { useEffect, useState } from "react";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import moment from "moment";
import { saveAs } from "file-saver";
import { Link, useNavigate } from "react-router-dom";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";

export default function TdsConsentReport() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("user_type");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const getReportData = async (pageNum) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${Constants.baseUrl}reports/retailerTdsConsentReport/list?sortBy=consentDate&sortAsc=false&limit=${limit}&page=${pageNum}`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
            appVersion: "1",
            platform: "website",
            company: "1",
            program: "1",
          },
        }
      );

      const dt = res.data;
      if (dt.result === "success") {
        setReportData(dt?.output?.results || []);
        setTotalPages(dt?.output?.totalPages || 0);
      } else {
        setReportData(null);
        setTotalPages(0);
      }
    } catch (err) {
      setReportData(null);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  const download = async () => {
    setLoading(true);
    setDownloadLoading(true);
    try {
      const res = await axios.get(
        `${Constants.baseUrl}reports/download/retailerTdsConsentReport`,
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
            appVersion: "1",
            platform: "website",
            company: "1",
            program: "1",
          },
          responseType: "blob",
        }
      );

      if (res.status === 200) {
        const fileData = new Blob([res.data], { type: "text/csv" });
        saveAs(fileData, "tdsConsentReport.csv");
      }
    } catch (err) {
    } finally {
      setLoading(false);
      setDownloadLoading(false);
    }
  };

  useEffect(() => {
    if (!token || userType !== "ADMIN") {
      navigate("/");
      return;
    }
    getReportData(1);
  }, [navigate, token, userType]);

  return (
    <>
      {loading ? <Oval /> : null}
      <Navbar />
      <section class="page-content--bge55">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h3 class="head1">Tds Consent Report</h3>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex justify-content-end">
                    <Link
                      to="#"
                      class={`btn btn-primary report-submit-button ${
                        downloadLoading ? "btn-opacity" : ""
                      }`}
                      onClick={download}
                    >
                      {downloadLoading ? (
                        <span>
                          {" "}
                          <i class="fa fa-spinner fa-spin"></i>Export
                        </span>
                      ) : (
                        " Export"
                      )}
                    </Link>
                  </div>
                </div>
              </div>
              <div class="row mt-20">
                <div class="col-md-12">
                  <div class="table-responsive table--no-card">
                    <table class="table table-borderless table-striped table-earning">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Retailer Id</th>
                          <th>Mobile No</th>
                          <th>Consent Date</th>
                          <th>Consent Status</th>
                        </tr>
                      </thead>
                      {!reportData || reportData.length === 0 ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="5"
                              style={{ textAlign: "center", fontSize: "16px" }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {reportData.map((item, index) => {
                            const serialNumber =
                              (currentPage - 1) * limit + index + 1;
                            const consentDate = item[2]
                              ? moment(item[2]).format("DD-MM-YYYY HH:mm:ss")
                              : "";

                            return (
                              <tr key={`${item[0]}-${index}`}>
                                <td>{serialNumber}</td>
                                <td>{item[0]}</td>
                                <td>{item[1]}</td>
                                <td>{consentDate}</td>
                                <td>{item[3]}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                    </table>
                    {totalPages > 1 && (
                      <ResponsivePagination
                        current={currentPage}
                        total={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          getReportData(page);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
